<template>
  <nav class="navbar navbar-expand-md navbar-light bg-light" v-if="authenticated">
    <a href="#" class="navbar-brand">
      <img :src="require('@/assets/logo.png')" height="28" alt="CoolBrand">
    </a>
    <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarCollapse">
      <div class="navbar-nav">
        <router-link class="nav-item nav-link active" to="/">Home</router-link>
        <router-link class="nav-item nav-link" to="/about">About</router-link>
        <a href="#" class="nav-item nav-link">Profile</a>
        <a href="#" class="nav-item nav-link">Messages</a>
        <a href="#" class="nav-item nav-link disabled" tabindex="-1">Reports</a>
      </div>
      <div class="navbar-nav ml-auto">
        <router-link class="nav-item nav-link" v-if="this.$authenticated" to="/login" v-on:click.native="logout()" replace>Logout</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Header',
  props: [
      'authenticated',
      'user'
  ],
  data() {
    return {
    }
  },
  methods: {
    logout() {
      this.$emit('logout');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/partials/Header.vue